export default "__VITE_ASSET__B0Pe80QS__"